<template>
    <div>

        <el-form @submit.native.prevent="onSubmitTurma" style="min-height: 200px;" :model="dados" ref="dados" label-position="top">

            <div class="style-form u-mt-20">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="20" :md="20">
                        <label>Instituição</label>
                        <el-select disabled v-model="dados.instituicao_id">
                            <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"> </el-option>
                        </el-select>
                    </el-col>
                    <el-col :xs="24" :sm="4" :md="4">
                        <label>Período Letivo</label>
                        <el-form-item key="periodo">
                            <el-select disabled v-model="dados.periodo_letivo_id">
                                <el-option v-for="(item, i) in $store.state.periodos" :key="i" :label="'Periodo Letivo ' + item.nome" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </div>
            <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="24">
                    <el-form-item label="Nome da Turma" prop="nome" :rules="[$requiredBlur]" key="nome">
                        <el-input :disabled="$store.state.user.tipo != 6 && $store.state.user.tipo != 4" v-model="dados.nome" maxlength="191" v-on:blur="formatData('nome')"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :xs="24" :sm="8" :md="8">
                    <el-form-item label="Situação" prop="situacao" :rules="[$requiredChange]" key="situacao">
                        <el-select :disabled="$store.state.user.tipo != 6 && $store.state.user.tipo != 4" v-model="dados.situacao">
                            <el-option v-for="(item, i) in $CONSTANTS.SITUACAO_TURMA" :key="i" :label="item" :value="parseInt(i)"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="8" :md="8">
                    <el-form-item label="Quantidade de Vagas" prop="qtd_vagas" :rules="[$requiredBlur, $dataBlur]" key="qtd_vagas">
                        <el-input :disabled="$store.state.user.tipo != 6 && $store.state.user.tipo != 4" v-model="dados.qtd_vagas" maxlength="191" v-mask="'###'"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="8" :md="8">
                    <el-form-item label="Turno" prop="turno" :rules="[$requiredChange]" key="turno">
                        <el-select :disabled="$store.state.user.tipo != 6 && $store.state.user.tipo != 4" v-model="dados.turno">
                            <el-option v-for="(item, i) in $CONSTANTS.TURNO" :key="i" :label="item" :value="parseInt(i)"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="24">
                    <el-form-item label="Tipo de Ensino" prop="tipo_ensino" :rules="[$requiredChange]" key="tipo_ensino">
                        <el-select @change="getCursosByTipoEnsino" :disabled="editTurma" v-model="dados.tipo_ensino">
                            <el-option v-for="(item, i) in $CONSTANTS.TIPO_ENSINO" :key="i" :label="item" :value="parseInt(i)"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :xs="24" :sm="18" :md="18">
                    <el-form-item label="Curso" prop="curso_id" :rules="[$requiredChange]" key="curso_id">
                        <el-select :disabled="editTurma" v-model="dados.curso_id" filterable>
                            <el-option v-for="(item, i) in selectCursos" :key="i" :label="item.nome" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="6" :md="6">
                    <el-form-item label="Qtd. aulas por dia letivo" prop="qtd_horarios" :rules="[$requiredBlur]" key="qtd_horarios">
                        <el-input :disabled="editTurma" v-model="dados.qtd_horarios" maxlength="191" v-mask="'#'"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="24">
                    <el-form-item label="Local diferenciado?" prop="local_diferenciado" :rules="[$requiredChange]" key="local_diferenciado">
                        <el-select v-model="dados.local_diferenciado">
                            <el-option v-for="(item, i) in $CONSTANTS.SALA_LOCAL_DIFERENCIADO" :key="i" :label="item" :value="parseInt(i)"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :xs="24" :sm="12" :md="12">
                    <el-form-item label="Horário Inicial de Funcionamento" prop="horario_inicial_funcionamento" key="horario_inicial_funcionamento">
                        <el-input v-model="dados.horario_inicial_funcionamento" maxlength="191" v-mask="'##:##'" v-on:blur="formatData('horario_inicial_funcionamento', 5)"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :md="12">
                    <el-form-item label="Horário Final de Funcionamento" prop="horario_final_funcionamento" key="horario_final_funcionamento">
                        <el-input v-model="dados.horario_final_funcionamento" maxlength="191" v-mask="'##:##'" v-on:blur="formatData('horario_final_funcionamento', 5)"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <!-- <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="24">
                    <el-form-item label="Dias da Semana" prop="diasFuncionamentoTurma" key="diasFuncionamentoTurma">
                        <el-select v-model="dados.diasFuncionamentoTurma" filterable multiple>
                            <el-option :key="1" label="DOMINGO" :value="1"></el-option>
                            <el-option :key="2" label="SEGUNDA" :value="2"></el-option>
                            <el-option :key="3" label="TERÇA" :value="3"></el-option>
                            <el-option :key="4" label="QUARTA" :value="4"></el-option>
                            <el-option :key="5" label="QUINTA" :value="5"></el-option>
                            <el-option :key="6" label="SEXTA" :value="6"></el-option>
                            <el-option :key="7" label="SÁBADO" :value="7"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row> -->
            <el-row :gutter="10" v-if="dados.tipo_ensino == 4">
                <el-col :xs="24" :sm="24" :md="24">
                    <el-form-item label="Atividade Complementar" prop="atividadesComplementares" :rules="[$requiredChange]" key="atividadesComplementares">
                        <el-select v-model="dados.atividadesComplementares" filterable multiple>
                            <el-option v-for="item in selectAtividadesComplementares" :key="item.id" :label="item.nome_atividade" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10" v-if="dados.tipo_ensino == 3">
                <el-col :xs="24" :sm="24" :md="24">
                    <el-form-item label="Tipos de Atendimentos Especializados" prop="tiposAtendimentosEspecializados" key="tiposAtendimentosEspecializados">
                        <el-select v-model="dados.tiposAtendimentosEspecializados" filterable multiple>
                            <el-option v-for="item in selectAtendimentosEspecializados" :key="item.id" :label="item.nome" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="10">
                <el-col :xs="24">
                    <div class="u-text-right u-mt-15">
                        <el-button type="primary" native-type="submit">SALVAR</el-button>
                    </div>
                </el-col>
            </el-row>
        </el-form>

    </div>
</template>
<script>

export default {
    props: ['paramId', 'instituicao', 'periodo_letivo'],
    data: () => ({
        editTurma: false,
        loadingAtividadesComp: false,
        selectAtividadesComplementares: [],
        selectAtendimentosEspecializados: [],
        dados:{
            nome: '',
            data_abertura: '',
            data_conclusao: '',
            turno: '',
            local_diferenciado: '',
            qtd_vagas: '',
            situacao: 1,
            periodo_letivo_id: '',
            instituicao_id: '',
            curso_id: '',
            tipo_ensino: '',
            horario_inicial_funcionamento: '',
            horario_final_funcionamento: '',
            diasFuncionamentoTurma: [],
            atividadesComplementares: [],
            tiposAtendimentosEspecializados: []

        },
        selectCursos: [],
        selectTiposEnsino: []
    }),
    mounted(){

        this.dados.instituicao_id = this.instituicao;
        this.dados.periodo_letivo_id = this.periodo_letivo;

        this.$axios.all([this.getAtividadesComplementares(), this.getAtendimentosEspecializados()]).then(this.$axios.spread((atividades, atendimentos)=>{

            this.selectAtividadesComplementares = JSON.parse(JSON.stringify(atividades.data));
            this.selectAtendimentosEspecializados = JSON.parse(JSON.stringify(atendimentos.data));

        })).catch((error) => { this.$store.commit('throwException', error); });

    },
    methods:{
        getAtividadesComplementares(){

            return this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/atividade-complementar/getAll`, this.$store.getters.getHeaderAuth);
        },
        getAtendimentosEspecializados(){

            return this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/tipo-atendimento-especializado/getAll`, this.$store.getters.getHeaderAuth);
        },
        getCursosByTipoEnsino(){

            if(!this.editTurma)
                this.dados.curso_id = '';

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/curso/getCursosByTipoEnsino/` + this.dados.tipo_ensino, this.$store.getters.getHeaderAuth).then(response => {

                this.selectCursos = JSON.parse(JSON.stringify(response.data));

            }).catch((error) => { this.$store.commit('throwException', error); });
        },
        getTurmaById(id){

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/turma/getById/` + id, this.$store.getters.getHeaderAuth).then(response => {

                this.dados = JSON.parse(JSON.stringify(response.data));
                this.getCursosByTipoEnsino(response.data.tipo_ensino);

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        onSubmitTurma(){

            this.$refs.dados.validate((valid) =>{ if(valid){

                window.eventBus.$emit('loading', true);

                this.dados.instituicao_id = this.$store.state.config.instituicao.id;
                this.dados.periodo_letivo_id = this.$store.state.config.periodo.id;

                if(this.editTurma){

                    this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/turma/update/${this.dados.id}`, this.dados, this.$store.getters.getHeaderAuth).then(response => {

                        if(typeof response.data.erro !== 'undefined'){

                            window.eventBus.$emit('loading', false);
                            window.eventBus.$emit('alert', {msg: response.data.erro.text, type: 'warning'});

                        }else{

                            window.eventBus.$emit('loading', false);
                            window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                            this.$emit('onSubmitTurma');

                        }


                    }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

                }else{

                    this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/turma/store`, this.dados, this.$store.getters.getHeaderAuth).then(response => {

                        window.eventBus.$emit('loading', false);
                        window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                        this.$emit('onSubmitTurma');

                    }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

                }

            }else{

                window.eventBus.$emit('alert', {msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning'});
            }});

        },
        formatData(field, size = null){

            //TRATA OS INPUTS - LETRA MAIÚCULA
            if(!this.dados[field])
                return false;

            if(size && this.dados[field].length < size)
                this.dados[field] = '';

            this.dados[field] = this.dados[field].toUpperCase();

            this.dados[field] = this.$removerAcentos(this.dados[field]);
        }
    },
    watch: {
        paramId: {
            immediate: true,
            handler (value) {

                if(value){

                    this.getTurmaById(value);
                    this.editTurma = true;
                }
            }
        },
    }
}
</script>